<div>
    <router-outlet></router-outlet>
</div>

<p-toast></p-toast>